import {Component, Input, OnInit} from '@angular/core';


@Component({
    selector: 'myupdates-delivery-bases',
    templateUrl: './delivery-bases.component.html',
    styleUrls: ['./delivery-bases.component.scss'],
    standalone: true
})
export class DeliveryBasesComponent implements OnInit {

  @Input() deliveryBases: string[] = [];

  // intentionally blank
  ngOnInit(): void {} // NOSONAR

}
